import { render, staticRenderFns } from "./TargetUrl.vue?vue&type=template&id=566029e4"
import script from "./TargetUrl.vue?vue&type=script&lang=js"
export * from "./TargetUrl.vue?vue&type=script&lang=js"
import style0 from "./TargetUrl.vue?vue&type=style&index=0&id=566029e4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports